/** App URLs for marketing CTAs. Local `vite` defaults to the Business app on 5173. */
const DEV = Boolean(import.meta.env.DEV);

export const WEB_URL = (
  import.meta.env.VITE_WEB_URL ?? (DEV ? 'http://localhost:5173' : 'https://app.cevop.com')
).replace(/\/$/, '');
export const POS_URL = (
  import.meta.env.VITE_POS_URL ?? (DEV ? 'http://localhost:5174' : 'https://pos.cevop.com')
).replace(/\/$/, '');
export const MARKETING_URL = (
  import.meta.env.VITE_MARKETING_URL ?? (DEV ? 'http://localhost:5180' : 'https://cevop.com')
).replace(/\/$/, '');

export const SIGNUP_URL = `${WEB_URL}/signup`;
export const LOGIN_URL = `${WEB_URL}/login`;
export const API_URL = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');

export function signupUrlForProduct(product: string): string {
  return `${SIGNUP_URL}?product=${encodeURIComponent(product)}`;
}
